import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '@services/settings.service';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-duty-settings',
  templateUrl: './duty-settings.component.html',
  styleUrls: ['./duty-settings.component.css'],
})
export class DutySettingsComponent implements OnInit {
  dutyForm: FormGroup;
  saving = false;

  constructor(
    private fb: FormBuilder,
    private settingsService: SettingsService,
    private notificationService: NotificationService
  ) {
    this.dutyForm = this.fb.group({
      dutyAmount: ['', [Validators.required, Validators.min(0)]],
    });
  }

  ngOnInit() {
    this.settingsService.loadSettings().subscribe((settings) => {
      this.dutyForm.patchValue({
        dutyAmount: settings.dutyAmount,
      });
    });
  }

  save() {
    if (this.dutyForm.invalid) {
      return;
    }

    const dutyAmount = parseFloat(this.dutyForm.value.dutyAmount);
    if (isNaN(dutyAmount) || dutyAmount < 0) {
      return;
    }

    this.saving = true;
    this.settingsService.updateDutyAmount(dutyAmount).subscribe({
      next: () => {
        this.saving = false;
        this.notificationService.show('success', 'DUTY AMOUNT SAVED');
      },
      error: () => {
        this.saving = false;
        this.notificationService.show('error', 'FAILED TO SAVE DUTY AMOUNT');
      },
    });
  }
}
